// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__oNwYa","author":"Table_author__1HaMG","authorImage":"Table_authorImage__9_xHB","unreadRow":"Table_unreadRow__2QrBf"};